<template>
    <app-layout>
      <Head title="Forms"/>
        <template #header>
            <div class="flex justify-between items-center">
                <div class="flex items-center">
                    <Link
                        :href="route('web-forms.index')"
                        class="p-1 text-gray-500 hover:text-gray-900"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M11 17l-5-5m0 0l5-5m-5 5h12"
                            />
                        </svg>
                    </Link>
                    <h2
                        class="font-semibold text-xl text-gray-800 leading-tight"
                    >
                        Form Preview
                    </h2>
                </div>
            </div>
        </template>

        <div class="max-w-7xl mx-auto flex mb-6">
            <div class="w-full py-6 px-4 sm:px-6 lg:px-8">
                <div class="grid grid-cols-12 gap-6">
                    <div
                        class="col-start-1 col-span-12 lg:col-start-4 lg:col-span-6"
                    >
                        <div class="bg-white overflow-hidden shadow rounded-lg">
                            <div class="px-4 py-5 sm:p-6">
                                <div class="grid grid-cols-12 gap-6">
                                    <div class="col-span-12 lg:col-span-6">
                                        <label
                                            for="first-name"
                                            class="block text-sm font-semibold text-gray-700"
                                            >First name
                                            <span class="text-red-500"
                                                >*</span
                                            ></label
                                        >
                                        <input
                                            type="text"
                                            autocomplete="off"
                                            disabled
                                            class="mt-1 px-3 py-2 focus:border-gray-400 focus:outline-none block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md"
                                            value="John"
                                        />
                                    </div>
                                    <div class="col-span-12 lg:col-span-6">
                                        <label
                                            for="last-name"
                                            class="block text-sm font-semibold text-gray-700"
                                            >Last name
                                            <span class="text-red-500"
                                                >*</span
                                            ></label
                                        >
                                        <input
                                            type="text"
                                            autocomplete="off"
                                            disabled
                                            class="mt-1 px-3 py-2 focus:border-gray-400 focus:outline-none block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md"
                                            value="Smith"
                                        />
                                    </div>
                                    <div class="col-span-12">
                                        <label
                                            for="form-name"
                                            class="block text-sm font-semibold text-gray-700"
                                            >Phone
                                            <span class="text-red-500"
                                                >*</span
                                            ></label
                                        >
                                        <input
                                            type="text"
                                            autocomplete="off"
                                            disabled
                                            class="mt-1 px-3 py-2 focus:border-gray-400 focus:outline-none block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md"
                                            value="(xxx) xxx-xxxx"
                                        />
                                    </div>
                                    <div class="col-span-12">
                                        <h2 class="font-medium">
                                            Subscribing to receive SMS/MMS messages from {{organization}}
                                        </h2>
                                    </div>
                                    <div class="col-span-12">
                                        <div class="relative flex items-start">
                                            <div class="flex items-center h-5">
                                                <input
                                                    aria-describedby="terms-description"
                                                    disabled
                                                    type="checkbox"
                                                    class="h-4 w-4 border-gray-300 rounded"
                                                />
                                            </div>
                                            <div class="ml-3 text-sm">
                                                <label
                                                    for="terms"
                                                    class="font-medium text-gray-700"
                                                    >Terms and conditions</label
                                                >
                                                <p
                                                    id="terms-description"
                                                    class="text-xs text-gray-500"
                                                >

                                                By providing a telephone number and submitting the form you are consenting to be contacted by SMS text message from {{ organization }}. Message frequency may vary. Message & data rates may apply. Reply STOP to opt out of further messaging. Reply HELP for more information. See our
                                                <span class="text-blue-500 underline cursor-pointer hover:text-blue-600">Privacy Policy</span>.
                                                See our
                                                <span class="text-blue-500 underline cursor-pointer hover:text-blue-600">Terms of Service</span>.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-span-12">
                                        <button
                                            type="button"
                                            class="inline-flex items-center justify-center w-full font-semibold px-3 py-3 border border-transparent leading-4 font-medium rounded-md shadow-sm text-white bg-orange-400 hover:bg-orange-500 focus:outline-none"
                                        >
                                            Subscribe now
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-6">
                            <div class="text-sm text-center text-gray-600">
                                SMS marketing powered by
                                <span
                                    class="text-blue-500 underline hover:text-blue-600 cursor-pointer"
                                    >TextSpot</span
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import JetButton from "../../Jetstream/Button";

export default {
    mounted() {},
    components: {
        AppLayout,
        JetButton
    },
    props: {
        group: Object,
        organization: String
    },
    data() {
        return {};
    },
    computed: {},

    methods: {}
};
</script>
